import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import LrapEnrollmentWizard from 'tio-employee/components/lrap/enrollment/wizard';
import type { AuthenticatedSlrLrapEnrollmentRouteModel } from 'tio-employee/routes/authenticated/slr/lrap/enrollment';

interface LrapEnrollmentRouteSignature {
  Args: {
    model: AuthenticatedSlrLrapEnrollmentRouteModel;
  };
}

const LrapEnrollmentRouteComponent: TOC<LrapEnrollmentRouteSignature> = <template>
  <div class="tio-col-tight">
    <h1 class="app-page-title tio-lrap-enrollment-title">{{t "lrap.enrollment.page_title"}}</h1>
    <LrapEnrollmentWizard @person={{@model.person}} />
  </div>
</template>;

export default LrapEnrollmentRouteComponent;
